import { render, staticRenderFns } from "./listar-vinculados.vue?vue&type=template&id=d6fd1e14&"
import script from "./listar-vinculados.vue?vue&type=script&lang=ts&"
export * from "./listar-vinculados.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6fd1e14')) {
      api.createRecord('d6fd1e14', component.options)
    } else {
      api.reload('d6fd1e14', component.options)
    }
    module.hot.accept("./listar-vinculados.vue?vue&type=template&id=d6fd1e14&", function () {
      api.rerender('d6fd1e14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pessoa/listar-vinculados.vue"
export default component.exports